const NUMBER = 3;

module.exports = { NUMBER };
